import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var SalesOrderPdfRes;
export const SalesOrderPdfTodo = createAsyncThunk('SalesOrderPdf', async (data) => {
    // console.log("data", data)
    const type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'so_pdf',
            data: {
                "vso_code": data
            },
            headers: { "Content-Type": "application/json" },

        })
        return SalesOrderPdfRes = res.data

    } catch (error) {
        return SalesOrderPdfRes = error.response.data
    }
});

const SalesOrderPdfSlice = createSlice({
    name: 'SalesOrderPdf',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(SalesOrderPdfTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(SalesOrderPdfTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default SalesOrderPdfSlice.reducer; 